import { getBoardSport, getBoardType } from "@sportactics/board-editing";
import { create } from "zustand";

import { useInterval } from "~utils";

import { AnalyticsEventType, useAnalyticsEvent } from "../../analytics-event";
import { useBoardState } from "../../board-state";
import { usePromptLimit } from "../../prompt-limit";
import {
  isRecentlyModified,
  minEngagedBoardElements,
  useBoardElementCount,
  useBoardLastModified,
} from "../../view-board";

export function usePromptShareFormation(): usePromptShareFormationReturn {
  const { shouldPromptDate } = useStore();
  return { shouldPromptDate };
}

export type usePromptShareFormationReturn = {
  shouldPromptDate?: Date;
};

export function usePromptShareFormationEffect(): void {
  const { board } = useBoardState();
  const { canPrompt, reportPrompted } = usePromptLimit();
  const { submitEvent } = useAnalyticsEvent();

  const elementCount = useBoardElementCount();
  const boardLastModified = useBoardLastModified();

  const { setShouldPromptDate } = useStore();

  useInterval((): void => {
    if (elementCount === undefined || elementCount <= minEngagedBoardElements)
      return;
    if (
      boardLastModified === undefined ||
      isRecentlyModified(boardLastModified)
    )
      return;
    if (!canPrompt) return;
    if (board === undefined) return;

    const now = new Date();
    setShouldPromptDate(now);
    reportPrompted(now);

    submitEvent({
      type: AnalyticsEventType.PromptShareFormation,
      sport: getBoardSport(getBoardType(board)),
    });
  });
}

const useStore = create<StoreState>((set) => ({
  setShouldPromptDate: (shouldPromptDate: Date) => set({ shouldPromptDate }),
}));

type StoreState = {
  shouldPromptDate?: Date;
  setShouldPromptDate: (date: Date) => void;
};
